import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailCreateItem } from '../../../external/MailCreateApi';
import { actions } from '../../modules/Actions';

export interface MailCreateState {
  mailTempMstList: MailCreateItem[]
}

export const initialState: MailCreateState = {
    mailTempMstList: [],
};

export const MailCreateReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailTempMstList,
  (state: MailCreateState, payload: MailCreateState) => {
    return payload;
  }
);
